// extracted by mini-css-extract-plugin
export default {"row":"Fitness_row__svsi4","col1":"Fitness_col1__JVADO","col2":"Fitness_col2__wLCSL","required":"Fitness_required__MNJSH"};